import React, { useEffect, useRef, useState } from "react";
import styles from "./deck-changer.module.css";
import { useDispatch, useSelector } from "react-redux";
import { changeDeckName, toNextDeck, toPrevDeck } from "../../store/reducers/list/deckList";
import { v4 } from "uuid";
import { selectDecks, selectSelectedIndex } from "../../store/selectors/deckSelectors";

export default function DeckChanger({ showEditButtons = true }) {
    const decks = useSelector((state) => selectDecks(state));
    const selectedIndex = useSelector((state) => selectSelectedIndex(state));

    const deckNameInputRef = useRef(null);

    const [isWriting, setIsWriting] = useState(false);
    const [text, setText] = useState("");

    const dispatch = useDispatch();

    const deckNameX = selectedIndex * 280;

    useEffect(() => {
        if (isWriting) deckNameInputRef.current.focus();
    }, [isWriting]);

    const onKeyPress = (e) => {
        if (e.key === "Enter" || e.key === "NumpadEnter") {
            dispatch(changeDeckName(e.target.value));
            setIsWriting(false);
        } else if (e.key === "Escape") {
            setIsWriting(false);
        }
    };

    return (
        <div className={styles["deck-changer"]}>
            <button
                type="button"
                className={styles["arrow"]}
                onClick={() => {
                    if (!isWriting) {
                        dispatch(toPrevDeck());
                    }
                }}
            >
                <i className="fi fi-rr-arrow-circle-left" />
            </button>
            <div className={styles["deck-names-wrapper"]}>
                <div className={styles["deck-names"]} style={{ transform: `translateX(-${deckNameX}px)` }}>
                    {decks.map((deck, index) => {
                        return (
                            <div
                                className={`${styles["deck-name"]} ${index === selectedIndex && isWriting ? `${styles["disabled"]}` : ""}`}
                                key={v4()}
                            >
                                {deck.name}
                            </div>
                        );
                    })}
                </div>
                <div className={`${styles["deck-name-change-input"]} ${isWriting ? `${styles["active"]}` : ""}`}>
                    <input
                        id="deck-name-input"
                        type="text"
                        ref={deckNameInputRef}
                        value={text}
                        onKeyDown={onKeyPress}
                        onChange={(e) => setText(e.target.value)}
                        enterKeyHint="done"
                    />
                </div>
            </div>
            {showEditButtons && (
                <div className={styles["deck-name-change-buttons"]}>
                    <button
                        type="button"
                        className={isWriting ? `${styles["disabled"]}` : ""}
                        onClick={() => {
                            setText(decks[selectedIndex].name);
                            setIsWriting(true);
                        }}
                    >
                        <i className="fi fi-rr-pen-circle" />
                    </button>
                    <button
                        type="button"
                        className={isWriting ? "" : `${styles["disabled"]}`}
                        onClick={() => {
                            dispatch(changeDeckName(text));
                            setIsWriting(false);
                        }}
                    >
                        <i className="fi fi-rr-check-circle" />
                    </button>
                    <button
                        type="button"
                        className={`${styles["cancel-button"]} ${isWriting ? "" : `${styles["disabled"]}`}`}
                        onClick={() => setIsWriting(false)}
                    >
                        <i className="fi fi-rr-circle-xmark" />
                    </button>
                </div>
            )}
            <button
                type="button"
                className={styles["arrow"]}
                onClick={() => {
                    if (!isWriting) {
                        dispatch(toNextDeck());
                    }
                }}
            >
                <i className="fi fi-rr-arrow-circle-right" />
            </button>
        </div>
    );
}
